import { Component, Inject, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { TaskDetailsComponent } from '../details/task-details.component';
import { TASK_CONFIG, TaskConfig } from '@features/tasks/services/task-config';
import { TaskService } from '@features/tasks/services/task.service';
import { TagService } from '@features/opportunities/services/tag.service';
import { Task } from '@features/tasks/models/task';
import { FormBuilder } from '@angular/forms';
import { commandEvent } from '@shared/components/load/command/command.component';

@Component({
  selector: 'app-task-new',
  templateUrl: '../details/task-details.component.html',
  styleUrls: ['../details/task-details.component.scss']
})
export class TaskNewComponent extends TaskDetailsComponent implements OnInit {
  constructor(
    @Inject(TASK_CONFIG) private readonly config: TaskConfig,
    taskService: TaskService,
    protected fb: FormBuilder,
    private tagService: TagService
  ) {
    super(taskService, fb);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.update$ = commandEvent(this.change$, (delta) =>
      this.taskService.updateTask(this.entityId, this.taskId, delta).pipe(
        switchMap(() => {
          if (this.pendingTags.length === 0) {
            return of({});
          }
          const requests = this.pendingTags.map(tag => ({ tagId: tag.tagId, tagName: tag.tagName }));
          return this.tagService.addTagsToTask(
            this.tagEntityType, this.entityId, this.taskId, requests
          ).pipe(map(() => ({})));
        })
      )
    );
  }

  get saveLabel(): string {
    return this.config.add.saveLabel;
  }

  get title(): string {
    return this.config.add.title;
  }

  readonly isEditMode = false;

  content(): Observable<Task.Model> {
    return of({} as Task.Model);
  }
}
